module.exports = __webpack_public_path__ + "media/advantage/whyWait-35f02fa5.jpg";